import * as leiocPaypalForm from './modules/newFormSubmit.js';

window.addEventListener("DOMContentLoaded", () => {
    if( document.querySelector('form.leioc-entry-form') ){
        leiocPaypalForm.formScripts();
    }
    if( document.querySelector('div.leioc-modal-paypal') ){
        leiocPaypalForm.modal();
    }
});